export default "__VITE_ASSET__Ld9fDOsv__"